import axios from 'axios'

export const SET_FIRST_TIME = 'SET_FIRST_TIME';
export const setFirstTime = () => ({
  type: SET_FIRST_TIME,
});

export const SET_LANGUAGE = 'SET_LANGUAGE'
export const setLanguage = (language) => ({
	type: SET_LANGUAGE,
	language
})

export const SET_CURRENCY = 'SET_CURRENCY'
export const setCurrency = (currency) => ({
	type: SET_CURRENCY,
	currency
})

export const SET_TIMEZONE = 'SET_TIMEZONE'
export const setTimezone = (timezone) => ({
	type: SET_TIMEZONE,
	timezone
})

export const SET_VERSION = 'SET_VERSION'
export const setVersion = (version) => ({
	type: SET_VERSION,
	version
})

export const START_BUTTON = 'START_BUTTON';
export const startButton = () => ({
  type: START_BUTTON,
});

// ------------------------------------ currency fetch ------------------------------------
export const CURRENCY_REQUEST = 'CURRENCY_REQUEST'
export const currencyRequest = () => ({
	type: CURRENCY_REQUEST
})

export const CURRENCY_RECEIVE = 'CURRENCY_RECEIVE'
export const currencyReceive = currencies => ({
	type: CURRENCY_RECEIVE,
	currencies
})

export const CURRENCY_ERROR = 'CURRENCY_ERROR'
export const currencyError = error => ({
	type: CURRENCY_ERROR,
	error
})

export const currencyFetch = () => {
	return dispatch => {
		dispatch(currencyRequest())

		axios.get('https://panel.betterpro.app/api/currencies', )
			.then(response => {
				dispatch(currencyReceive(response.data.content))
				console.log('+++++++=', response.data.content)
			})
			.catch(error => {
				dispatch(currencyError(error.response))
			})
	}
}

// ------------------------------------ timezones fetch ------------------------------------
export const TIMEZONES_REQUEST = 'TIMEZONES_REQUEST'
export const timezonesRequest = () => ({
	type: TIMEZONES_REQUEST
})

export const TIMEZONES_RECEIVE = 'TIMEZONES_RECEIVE'
export const timezonesReceive = timezones => ({
	type: TIMEZONES_RECEIVE,
	timezones
})

export const TIMEZONES_ERROR = 'TIMEZONES_ERROR'
export const timezonesError = error => ({
	type: TIMEZONES_ERROR,
	error
})

export const timezonesFetch = () => {
	return dispatch => {
		dispatch(timezonesRequest())

		axios.get('https://panel.betterpro.app/api/timezones', )
			.then(response => {
				dispatch(timezonesReceive(response.data.content))
			})
			.catch(error => {
				dispatch(timezonesError(error.response))
			})
	}
}


